/** @typedef {{	features: (string | string[])[] }} Props */

import { BaseSVG } from '../BaseSVG';
import images from '../../config/local/images';
import React from 'react';

/**
 * @param	{Props} props
 * @returns {JSX.Element | null}
 */
function SubscriptionPoints(props) {
	if (!props?.features?.length) {
		return null;
	}

	/**
	 * @param {string | string[]} feature
	 * @returns {JSX.Element	| JSX.Element[]}
	 */
	function getPoints(feature) {
		if (Array.isArray(feature)) {
			return feature.map((subFeature) => (
				<li
					className="flex gap-1 mb-2 ml-14"
					// eslint-disable-next-line react/no-danger -- Markdown text
					dangerouslySetInnerHTML={{
						__html: subFeature,
					}}
					key={subFeature}
				/>
			));
		}

		return (
			<li className="flex gap-1 mb-2" key={feature}>
				<i>
					<BaseSVG
						className="h-4 w-4 mr-2 icon icon-fill"
						path={images.icons.check}
					/>
				</i>

				<p
					// eslint-disable-next-line react/no-danger -- Markdown text
					dangerouslySetInnerHTML={{
						__html: feature,
					}}
				/>
			</li>
		);
	}

	return <ul>{props?.features.map(getPoints)}</ul>;
}

export default React.memo(SubscriptionPoints);
